import React from 'react';
import { TeamMember } from '../data/team';

export const TeamMemberCard: React.FC<{ member: TeamMember; onReadMore: () => void; }> = ({ member, onReadMore }) => (
    <div className="text-center group">
        <div className="relative inline-block mb-4">
            <img src={member.imageUrl} alt={member.name} className="w-40 h-40 rounded-full object-cover border-4 border-background shadow-lg group-hover:shadow-xl transition-shadow duration-300" />
        </div>
        <h3 className="text-xl font-bold text-foreground font-heading">{member.name}</h3>
        <p className="text-primary font-semibold mb-3">{member.title}</p>
        <button
          onClick={onReadMore}
          className="text-sm font-semibold text-muted-foreground group-hover:text-primary transition-colors cursor-pointer"
        >
          View Bio &rarr;
        </button>
    </div>
);
